export default __webpack_public_path__ + "static/media/header.e6e35760.jpg";